export class user{
  userId:string='';
  name:string='';//姓名
  phoneNumber:string='';//手机号
  idNumber:string='';//身份证号
  password:string='';//密码
  passwordAgain:string='';//再次输入密码
  token:string='' //条款
};